import { Search } from 'lucide-react';
import { useEffect, useRef } from 'react';

interface PaletteInputProps {
  value: string;
  onChange: (v: string) => void;
}

export function PaletteInput({ value, onChange }: PaletteInputProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <div className="flex items-center gap-3 border-b border-white/8 px-4 py-3">
      <Search size={16} className="shrink-0 text-text-secondary" />
      <input
        ref={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Søk i saker, e-post, dokumenter, personer…"
        className="flex-1 bg-transparent text-sm text-text-primary placeholder:text-text-secondary outline-none"
        aria-label="Søk"
        role="combobox"
        aria-expanded="true"
        aria-autocomplete="list"
        autoComplete="off"
        spellCheck={false}
      />
      <kbd className="hidden shrink-0 rounded border border-white/10 px-1.5 py-0.5 text-[10px] text-text-secondary sm:block">
        ESC
      </kbd>
    </div>
  );
}
